import { Component, EventEmitter, ElementRef, forwardRef, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { BaseService } from 'src/modules/base/shared/services/base.service';
import { AlertsService } from '../../services/alerts.service';
import { LoaderService } from '../../services/loader.service';
import { StorageService } from '../../shared/services/storage.service';
import { DomSanitizer } from '@angular/platform-browser';
import { NgxImageCompressService } from 'ngx-image-compress';
import { Observable } from 'rxjs';
import { DialogService } from '../dialog/dialog.service';
import { DialogModalSize } from '../dialog/dialog-ref';
import { FileManagerComponent } from '../file-manager/file-manager.component';

@Component({
    selector: 'app-document-with-thumbnail',
    templateUrl: './document-with-thumbnail.component.html',
    styleUrls: ['./document-with-thumbnail.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => DocumentWithThumbnailComponent),
            multi: true
        }
    ],
    standalone: false
})
export class DocumentWithThumbnailComponent implements OnInit, OnDestroy {
  @Input() datasource: any = 'file_document';
  availableDocuments: any;
  @Output() valueChange = new EventEmitter<any>();
  @Input() question: any;
  @Input('value') _value: any;
  propagateChange = (_: any) => { };
  onTouched: any = () => { };
  selectedDocument: any;
  cardData: any;
  tempArray = [];
  pagination: any = {
    page_size: 10,
    page_no: 0
  };
  uniqueString: string;
  manually_added: any[];
  cropQueue: Array<any> = [];
  applyCropShown = false;
  // applyCropApplied = false;
  lastCropData: any = {};
  draggingItemIndex: number | null = null;
  sequenceNumber: number = 0;
  filesCount: number = 0;
  readonly MAX_CHAR_LIMIT: number = 50; // Maximum characters allowed in file name
  isComponentArrayType: boolean = false;
  openClientFileManager = false; /** Flag to control client file manager popup */

  constructor(
    private baseService: BaseService, private storageService: StorageService, private alerts: AlertsService, private loader: LoaderService,
    private sanitizer: DomSanitizer, private imageCompress: NgxImageCompressService, private dialogService: DialogService
  ) { }

  /** Handler for Select File click */
  onSelectFile(event: MouseEvent): void {
    if (this.openClientFileManager) {
      event.preventDefault();
      const config = {
        title: 'Select Files',
        size: DialogModalSize.Lg,
        className: 'modal-lg'
      };
      this.dialogService.open(FileManagerComponent, config)
        .afterClosed
        .subscribe(async result => {
          if (result && Array.isArray(result) && result.length > 0) {
            // Convert URLs to File objects and then pass to onChange
            this.loader.showSpinner(); // Show spinner during file conversion
            const files: File[] = [];
            for (const imageUrl of result) {
              try {
                const response = await fetch(imageUrl);
                const blob = await response.blob();
                const filename = imageUrl.substring(imageUrl.lastIndexOf('/') + 1);
                const file = new File([blob], filename, { type: blob.type });
                files.push(file);
              } catch (error) {
                console.error(`Error fetching or converting image from URL: ${imageUrl}`, error);
                this.alerts.error(`Failed to process image from URL: ${imageUrl}`);
              }
            }
            this.loader.hideSpinner(); // Hide spinner after conversion

            // Simulate a native file input event
            const simulatedEvent = {
              target: {
                files: files
              }
            } as any; // Cast to any to match the onChange event signature loosely

            // Call the existing onChange method to process these files
            this.onChange(simulatedEvent);
          }
        }, err => {
          console.error('Error opening File Manager:', err);
          this.alerts.error('Failed to open file manager.');
        });
    }
  }


  get value(): any {
    return this._value;
  }

  set value(val) {
    this._value = val;
    this.propagateChange(val);
    this.onTouched();
  }

  writeValue(value) {
    if (value) {
      this.value = value;
    } else {
      if(this.question && this.question.type && this.question.type == 'array')
        this.value = [];
      else
        this.value = "";
    }
  }
  registerOnChange(fn: any) {
    this.propagateChange = fn;
  }
  registerOnTouched(fn: any) {
    this.onTouched = fn;
  }

  ngOnInit(): void {
    console.log("DOcument Thumbnail component");
    if (!this.manually_added) {
      this.manually_added = [];
    }
    if(this?.question?.type === "array") {
      this.isComponentArrayType = true;
    }
    this.uniqueString = 'input-' + Math.random().toString(36).substring(2, 15)
    // this.baseService.getResourceDef(this.resource, (resourceDef) => {
    this.storageService.getSessionStorageData("currentData", (data) => {
      if (data)
        this.cardData = data;
      if (this.datasource != undefined) {
        let apiResource = this.datasource;
        //added for emr physiotherapy patient
        if (this.cardData && this.cardData.speciality_id == undefined && this.cardData.extra_data && this.cardData.extra_data.performingDoctorSpecialityId != undefined) {
          this.cardData['speciality_id'] = this.cardData.extra_data.performingDoctorSpecialityId;
        }
        apiResource.args = this.baseService.buildDyanamicStr(apiResource.args, { data: this.cardData });
        apiResource.filter = this.baseService.buildDyanamicStr(apiResource.filter, { data: this.cardData });
        let obj = {
          args: apiResource.args ? apiResource.args : '', filter: apiResource.filter ? apiResource.filter : '', page_no: this.pagination.page_no,
          page_size: this.pagination.page_size,
        }
        this.baseService.getData(obj, '', apiResource.resource, apiResource.application, apiResource.query_id).subscribe(res => {
          if (res != undefined && res.errCode == 0) {

            const manualForPage = (this?.manually_added || [])?.filter(d => d?.page_no === this?.pagination?.page_no).reverse();
            this.availableDocuments = [...manualForPage, ...(res?.resource?.length > 0 ? res.resource : [])];
            this.pagination['count'] = res?.count + manualForPage?.length;

            this.getUrls();
          }
          else {
            this.alerts.error(res.message);
          }

        })
      }
    })
    // })
  }
  goPrev() {
    if (this.pagination['page_no'] && this.pagination['page_no'] != 0 && this.pagination['count'] > this.pagination['page_no']) {
      this.pagination['page_no'] = this.pagination['page_no'] - 1;
      this.ngOnInit();
    }
  }
  goNext() {
    this.pagination['page_no'] = this.pagination['page_no'] + 1;
    this.ngOnInit();
  }

  /**
   * Handles the event when an image is cropped within the cropper component.
   *
   * This method is triggered when the user finishes cropping an image. It updates
   * the cropQueue with the cropped base64 image, cropper position, image position,
   * width, and height. It also sets the hasCropped flag to false, indicating that
   * the image is not crop.
   *
   * @param event - The event emitted by the image cropper component, containing
   *                the cropped base64 image and related data.
   * @param idx - The index of the image within the cropQueue that was cropped.
   */
  onImageCropped(event, idx) {
    this.cropQueue[idx].croppedImage = event.base64;
    this.cropQueue[idx].cropperPosition = event.cropperPosition;
    this.cropQueue[idx].imagePosition = event.imagePosition;
    this.cropQueue[idx].width = event.width;
    this.cropQueue[idx].height = event.height;
    this.cropQueue[idx].hasCropped = false;
    if(this.cropQueue[idx].originalImageHeight == undefined || this.cropQueue[idx].originalImageWidth == undefined){
      this.cropQueue[idx].originalImageHeight = event.height;
      this.cropQueue[idx].originalImageWidth = event.width;
    }
    console.log(`event at index ${idx}`, event);
  }

  /**
   * Applies the same crop to all uncropped images in the crop queue.
   *
   * This method iterates through all uncropped images in the cropQueue, applies
   * the same crop settings (defined by lastCropData), and updates the
   * availableDocuments array with the cropped images.
   */
  async applyCropToAll(){
    
    if(!this.lastCropData || 
       !this.lastCropData.cropperPosition || 
       !this.lastCropData.originalImageWidth || 
       !this.lastCropData.originalImageHeight) {
      console.error("lastCropData is not properly set with cropperPosition and original dimensions. Cannot apply crop to all.");
      return;
    }

    const uncroppedItems = this.cropQueue.filter(item => !item.hasCropped);

    // Process each uncropped image sequentially
    for (const cropItem of uncroppedItems) {
      const originalFile = cropItem.originalFile;
      const imageUrl = await new Promise<string>((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = async (e) => {
          try{
            const base64 = e.target?.result as string;
            
            let croppedBase64 = await this.cropBase64Image(
              base64,
              this.lastCropData.imagePosition,
              this.lastCropData.originalImageWidth,
              this.lastCropData.originalImageHeight,
              cropItem?.type
            ) as string;

            let finalImageUrl = await this.compressImage(croppedBase64, cropItem?.size);


            resolve(finalImageUrl);
          } catch (error) {
            console.error(`Error during applyCropToAll for ${originalFile.name}: `, error);
            resolve(e.target.result as string);
          }
        };
        reader.onerror = (err) => {
          console.error(`FileReader error in applyCropToAll for ${originalFile.name}:`, err);
          reject(`FileReader error for ${originalFile.name}`);
        }
        reader.readAsDataURL(originalFile);
      });

      this.addProcessedImage(
        originalFile,
        imageUrl,
        originalFile.name,
        cropItem?.sequence
      )

      // const fileVal = {
      //   file: originalFile,
      //   imageUrl: imageUrl,
      //   filetype: 'file',
      //   fileName: originalFile.name,
      //   image: URL.createObjectURL(originalFile),
      //   sequence: cropItem?.sequence
      // };

      // this.availableDocuments.unshift(fileVal);
      // this.manually_added.push(fileVal);
      // this.viewImage(this.availableDocuments[0]);
      // this.processDocument({ "imageUrl": fileVal.imageUrl }, fileVal);
      cropItem.hasCropped = true;
    }

    // Remove all uncropped items from cropQueue
    this.cropQueue = this.cropQueue.filter(item => !item.hasCropped);
  }


  /**
   * Asynchronously crops a base64 image to a specified region.
   *
   * This method takes a base64 encoded image and crops it based on the provided
   * image position, original width, and original height. It returns a Promise
   * that resolves with the cropped base64 image.
   *
   * @param base64 - The base64 encoded image to crop.
   * @param imagePosition - The position of the crop area within the original image,
   *                          specified as an object with x1, y1, x2, and y2 coordinates.
   * @param originalWidth - The original width of the image.
   * @param originalHeight - The original height of the image.
   * @returns A Promise that resolves with the cropped base64 image, or rejects
   *          if an error occurs during the cropping process.
   */
  async cropBase64Image(
    base64: string,
    imagePosition: { x1: number; y1: number; x2: number; y2: number },
    originalWidth: number,
    originalHeight: number,
    type: string
  ): Promise<string> {
    // 1. Load the target image so we can read its true size
    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.src = base64;
    await new Promise<void>((res, rej) => {
      img.onload  = () => res();
      img.onerror = err => rej(err);
    });
    const natW = img.naturalWidth;
    const natH = img.naturalHeight;

    // 2. Compute how much larger/smaller this image is vs. the original
    const scaleX = natW / originalWidth;
    const scaleY = natH / originalHeight;

    // 3. Scale your saved box from Image A into Image B’s pixel grid
    const sx = imagePosition.x1 * scaleX;
    const sy = imagePosition.y1 * scaleY;
    const sw = (imagePosition.x2 - imagePosition.x1) * scaleX;
    const sh = (imagePosition.y2 - imagePosition.y1) * scaleY;

    // 4. Draw *that* region into a canvas of exactly the same size
    const canvas = document.createElement('canvas');
    canvas.width  = Math.round(sw);
    canvas.height = Math.round(sh);
    const ctx = canvas.getContext('2d')!;
    ctx.drawImage(
      img,
      sx, sy, sw, sh,   // source rect on the natural image
      0,  0, sw, sh     // destination on the new canvas
    );

    // 5. Return a Base64 PNG of the cropped area
    return canvas.toDataURL(type, 1.0);
  }

  /**
   * Asynchronously crops a base64 image to a specified region.
   *
   * This method takes a base64 encoded image and crops it based on the provided
   * image position, original width, and original height. It returns a Promise
   * that resolves with the cropped base64 image.
   *
   * @param base64 - The base64 encoded image to crop.
   * @param imagePosition - The position of the crop area within the original image,
   *                          specified as an object with x1, y1, x2, and y2 coordinates.
   * @param originalWidth - The original width of the image.
   * @param originalHeight - The original height of the image.
   * @returns A Promise that resolves with the cropped base64 image, or rejects
   *          if an error occurs during the cropping process.
   */
  async confirmCrop(idx) {
    const cropData = this.cropQueue[idx];
    let imageUrl = cropData.croppedImage;
    const fileName = cropData.originalFile.name;
    console.log('(CC) fileName is ', fileName);
    imageUrl = await this.compressImage(imageUrl, cropData?.size);

    this.addProcessedImage(
      cropData.originalFile,
      imageUrl,
      fileName,
      cropData?.sequence
    );

    // const fileVal = {
    //   file: cropData.originalFile,
    //   imageUrl: cropData.croppedImage,
    //   filetype: 'file',
    //   fileName: fileName,
    //   image: URL.createObjectURL(cropData.originalFile),
    //   sequence: cropData?.sequence
    // };
    
    
    // this.availableDocuments.unshift(fileVal);
    // this.manually_added.push(fileVal);
    // this.viewImage(this.availableDocuments[0]);
    // this.manually_added.forEach(ele => {
    // this.processDocument({ "imageUrl": fileVal.imageUrl }, fileVal);
    // });
    

    if(!this.applyCropShown && this.filesCount > 1){
      this.lastCropData = cropData;
      this.applyCropShown = true;

      this.baseService.modalService.confirmCustomBtn(
        "Confirmation",
        "Do you want to apply the same crop on all images?",
        "sm"
        ).subscribe(result => {
        if (result) {
          this.applyCropToAll();
        } else {
          console.log("User choose not to apply crop to all images.");
        }
      });
    }

    // Remove from crop queue
    this.cropQueue.splice(idx, 1);
  }

  /**
   * Adds a processed image to the list of available documents and updates related arrays.
   * It also initiates the viewing of the new image and processes it for storage/upload.
   *
   * @param originalFile - The original File object that was processed.
   * @param imageUrl - The data URL or accessible URL of the processed image.
   * @param fileName - The name of the file.
   * @param sequence - The sequence number for ordering the document.
   */
  addProcessedImage(originalFile, imageUrl, fileName, sequence){
    const fileVal = {
      file: originalFile,
      imageUrl: imageUrl,
      filetype: 'file',
      fileName: fileName,
      image: URL.createObjectURL(originalFile),
      sequence: sequence,
      page_no: this?.pagination?.page_no
    };

    this.availableDocuments.unshift(fileVal);
    this.manually_added.push(fileVal);
    this.pagination['count'] = (this?.pagination?.['count'] || 0) + 1;
    this.viewImage(this.availableDocuments[0]);
    this.processDocument({ "imageUrl": fileVal.imageUrl }, fileVal);
  }

  /**
   * Determines if image compression is needed based on the provided size.
   * Compression is considered necessary if the size is 1MB (1048576 bytes) or larger.
   *
   * @param size - The size of the image in bytes.
   * @returns A Promise that resolves to true if compression is needed, false otherwise.
   */
  async isCompressionNeeded(size): Promise<boolean> {
    return size >= 1048576;
  }

  /**
   * Compresses a base64 encoded image if its original size meets the compression threshold.
   * It uses ngx-image-compress for the compression.
   *
   * @param base64Image - The base64 encoded string of the image to be compressed.
   * @param originalUploadedFileSize - The size of the original file (in bytes) that this image was derived from.
   *                                   This size is used to determine if compression should be attempted.
   * @returns A Promise that resolves to the base64 string of the compressed image,
   *          or the original base64 string if compression was not needed or failed.
   */
  async compressImage(base64Image, size): Promise<string> {
    if(!(await this.isCompressionNeeded(size))) {
      console.log("No compression needed.");
      return Promise.resolve(base64Image);
    }

    const orientation = -1; // DOC_ORIENTATION.Default
    const ratio = 50;       // Reduce dimensions to 50%
    const quality = 50;     // JPEG quality 50%

    const compressedImage = await this.imageCompress.compressFile(
      base64Image,
      orientation,
      ratio,
      quality
    );
    const tempFile = this.dataURLtoFile(compressedImage, 'tempImageForSizeCheck.'+size);
    const compressedSize = await this.getOriginalFileSize(tempFile);
    console.log('Compressed image size (bytes):', compressedSize);

    return Promise.resolve(compressedImage);
  }

  /**
   * Retrieves the size of a File object in bytes.
   * This method uses FileReader to read the file as an ArrayBuffer and returns its byteLength.
   *
   * @param file - The File object whose size is to be determined.
   * @returns A Promise that resolves with the file size in bytes, or rejects if an error occurs.
   */
  async getOriginalFileSize(file: File): Promise<number> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (event) => {
        if (event.target && event.target.result instanceof ArrayBuffer) {
          resolve(event.target.result.byteLength);
        } else {
          reject(new Error('Failed to read file as ArrayBuffer.'));
        }
      };
      reader.onerror = (error) => {
        console.error('FileReader error:', error);
        reject(error);
      };
      reader.readAsArrayBuffer(file);
    });
  }

  /** 
   * Replaces dots with hashes, trims symmetrically, appends a short hash,
   * and guarantees a total length of exactly MAX_CHAR_LIMIT.
   */
  sanitizeFileName(fileName: string): string {
    const lastDotIndex = fileName.lastIndexOf('.');
    if (lastDotIndex < 0) return fileName;

    const baseName = fileName.substring(0, lastDotIndex);
    const extension = fileName.substring(lastDotIndex);  // includes the “.”
    const totalDots = (fileName.match(/\./g) || []).length;

    // Only sanitize if there’s more than one dot or it’s too long
    if (totalDots <= 1 && fileName.length <= this.MAX_CHAR_LIMIT) {
      return fileName;
    }

    // 1) Replace all internal dots with hashes
    const baseWithHashes = baseName.replace(/\./g, '#');

    // 2) Create a 6‑char deterministic hash from the full filename
    const hashPart = `#${this.simpleHash(fileName)}`;   // length = 7

    // 3) Compute how many chars remain for the base
    const extensionLen   = extension.length;           
    const hashPartLen    = hashPart.length;            
    const remainingLen   = this.MAX_CHAR_LIMIT - extensionLen - hashPartLen;

    // 4) Trim the base symmetrically to fit
    let trimmedBase: string;
    if (baseWithHashes.length <= remainingLen) {
      // If shorter, you could pad here—but often not needed
      trimmedBase = baseWithHashes;
    } else {
      const firstHalfLen  = Math.floor(remainingLen / 2);
      const secondHalfLen = remainingLen - firstHalfLen;
      const startSegment  = baseWithHashes.substring(0, firstHalfLen);
      const endSegment    = baseWithHashes.substring(baseWithHashes.length - secondHalfLen);
      trimmedBase = startSegment + endSegment;
    }

    // 5) Concatenate everything
    return trimmedBase + hashPart + extension;
  }

  /**
  * Simple, deterministic 6‑char hash for a string.
  * Uses bitwise operations for speed and .toString(36) for compactness.
  */
  simpleHash(input: string): string {
    let hash = 0;
    for (let i = 0; i < input.length; i++) {
      hash = ((hash << 5) - hash) + input.charCodeAt(i);
      hash |= 0;  // to 32‑bit int
    }
    // Convert to positive base‑36 and take 6 chars
    return (Math.abs(hash)).toString(36).substring(0, 6);
  }

  /**
   * Handles the file input change event.
   *
   * This method is triggered when files are selected via the file input.
   * It processes each selected file, performs filename validation,
   * and adds the file to the crop queue for further processing.
   *
   * @param event - The file input change event.
   */
  onChange(event) {
    const that = this;
    console.log("Event is ", event);
    let fl = event.target.files;
    this.filesCount = fl.length;
    let count = (fl.length + that.pagination['count']);
    for (let i = 0; i < fl.length; i++) {

      const originalFile = fl[i];
      const sanitizedName = this.sanitizeFileName(originalFile.name);

      const fileToProcess = (sanitizedName !== originalFile.name)
        ? new File([originalFile], sanitizedName, {type: originalFile.type})
        : originalFile;

      if (sanitizedName !== originalFile.name) console.log(`Filename sanitized from "${originalFile.name}" to "${fileToProcess.name}"`);

      let originalSizeBytes = 0;

      this.getOriginalFileSize(fileToProcess).then(size => {
        originalSizeBytes = size;
        console.log(`Original size of ${fileToProcess.name}: ${size} bytes`);
      }).catch(error => {
        console.error(`Could not get original file size for ${fileToProcess.name}:`, error);
      }).finally(async () => {
        console.log("fileToProcess: ", fileToProcess);
        if(this?.isComponentArrayType){
          that.cropQueue.push({
            imageChangedEvent: { target: { files: [fileToProcess] } },
            showCropper: true,
            originalFile: fileToProcess,
            format: fileToProcess.type.split('/')[1] || 'png',
            sequence: ++this.sequenceNumber,
            size: originalSizeBytes,
            type: fileToProcess.type,
          });
          console.log("CropQueue: ", that.cropQueue);
        } else {
          const base64Image = await new Promise<string>((resolve, reject) => {
              const reader = new FileReader();
              reader.onload = (e) => resolve(e.target?.result as string);
              reader.onerror = (err) => reject(err);
              reader.readAsDataURL(fileToProcess);
            });
          let imageUrl = await this.compressImage(base64Image, originalSizeBytes);

          this.addProcessedImage(
            fileToProcess,
            imageUrl,
            sanitizedName,
            ++this.sequenceNumber
          );
        }
      });

    }
  }

  getClassToEnableDisableIcon() {
    if(this.pagination['count'] == this.pagination.page_size)
      return '';
    else if (this.pagination['count'] > 0) {
      var lastPage = this.pagination['count'] / this.pagination.page_size;
      if (lastPage > this.pagination['page_no'] + 1) {
        return '';
      } else {
        return 'errors';
      }
    }
  }
  getUrls() {
    // if(this.question && this.question.value != undefined && this.value != '' && this.value != 0 && this.value != '0'){
    //   this.availableDocuments.forEach(document => {
    //     document.imageUrl = this.baseService.getApiEndpoint("dms") + (document.dms_resource ? document.dms_resource : document.document_type ? document.document_type : 'emrImage') + '/image-response-entity?args=id:' + (document.imageId ? document.imageId : document.documentId) + '&application=dms';
    //   });
    //   try{
    //     if(typeof(this.question.value) == 'string'){
    //       this.question.value = JSON.parse(this.question.value);
    //     }
    //   }catch (error){
    //     console.log("Error is ",error);
    //   }
    //   this.question.value.forEach(document => {
    //     document.imageUrl = this.baseService.getApiEndpoint("dms") + (document.dms_resource ? document.dms_resource : document.document_type ? document.document_type : 'emrImage') + '/image-response-entity?args=id:' + (document.imageId ? document.imageId : document.annotatedDocument) + '&application=dms';
    //   });
    //   this.viewImage(this.question.value[0]);
    // }else 
    if(this.question && this.question.type && this.question.type == 'array' && this.tempArray && this.tempArray.length == 0 && this.value.length > 0){
      try{
        if(typeof(this.value) == 'string')
          this.tempArray = JSON.parse(this.value);
        else
          this.tempArray = this.value;
      }catch(e){
        this.tempArray = this.value;
      }
      this.tempArray.forEach(ele => {
        ele.imageUrl = this.baseService.getApiEndpoint("dms") + 'emrImage' + '/image-response-entity?args=id:' + ele.annotatedDocument + '&application=dms';
      })
    }
    if (this.availableDocuments != undefined && this.availableDocuments.length != undefined && this.availableDocuments.length) {
      this.availableDocuments.forEach(document => {
        if (document?.imageId || document?.documentId) {
          document.imageUrl = this.baseService.getApiEndpoint("dms") + (document.dms_resource ? document.dms_resource : document.document_type ? document.document_type : 'emrImage') + '/image-response-entity?args=id:' + (document.imageId ? document.imageId : document.documentId) + '&application=dms';
        }
      });
      const showFirstAvailable = () => {
        if (Array.isArray(this.availableDocuments) && this.availableDocuments.length > 0) {
          this.viewImage(JSON.parse(JSON.stringify(this.availableDocuments[0])));
        }
      };
      if(!this?.isComponentArrayType){
        if(!this.value || (typeof this.value === 'string' && this.value.trim() === '')){
          // this.viewImage(this.availableDocuments[0])
          showFirstAvailable();
        }else{
          // let document = JSON.parse(JSON.stringify(this.value));
          // try{
          //   document = JSON.parse(this.value);
          //   this.viewImage(document[0]);
          // }catch(error){
          //   try{
          //     this.viewImage(this.value[0]);
          //   }catch(err){
          //     this.viewImage(this.availableDocuments[0])
          //   }
          // }
          let documentArr: any[] = [];
          try {
            documentArr = typeof this.value === 'string' ? JSON.parse(this.value) : this.value;
            if (Array.isArray(documentArr) && documentArr.length > 0) {
              this.viewImage(JSON.parse(JSON.stringify(documentArr[0])));
            } else {
              console.log('No documents found in value');
            }
          } catch (error) {
              showFirstAvailable();
          }
        }
      } else {
        // this.viewImage(this.availableDocuments[0])
          showFirstAvailable();
      }
    }
  }
  viewImage(document) {
    this.selectedDocument = false;
    setTimeout(x => {
      let doc = JSON.parse(JSON.stringify(document));
      this.selectedDocument = doc
    })
    this.setUpdate(document);
  }

  processDocument(event, selectedDocument) {
    console.log("selected dicoms at update", event, selectedDocument);
    this.loader.showSpinner();
    selectedDocument.json = event
    let docType = selectedDocument.dms_resource ? selectedDocument.dms_resource : selectedDocument.document_type ? selectedDocument.document_type : 'emrImage'
    const fd = new FormData()
    fd.append('action', 'add');
    fd.append('fileName', selectedDocument.fileName ? selectedDocument.fileName : 'samplefile.png');
    fd.append('file', this.dataURLtoFile(event.imageUrl, selectedDocument.fileName ? selectedDocument.fileName : 'samplefile.png'))
    this.baseService.upload(fd, 'dms', docType, event.imageUrl).subscribe(res => {
      if (res.errCode == 0) {
        //this is update
        if (this.value != undefined && this.value && this.value.length != undefined && this.value.length > 0) {
          if(this.question && this.question.type && this.question.type == 'array'){
            this.setArray(selectedDocument, res, event);
          }else{
            let arr = this.value;
            let imgId = selectedDocument.imageId ? selectedDocument.imageId : selectedDocument.documentId;
            if (typeof arr === "string") {
              try {
                arr = JSON.parse(arr);
              } catch (error) {}
            }
            let val = arr.find(x => x.document === imgId);
            if (val != undefined && val) {
              val['annotationJson'] = event.state;
              val['annotatedDocument'] = res.documentId;
              this.value = JSON.stringify(arr);
              this.setArray(selectedDocument, res, event);
            }else {
              this.setArray(selectedDocument, res, event);
            }
          }
        }else {
          this.setArray(selectedDocument, res, event);
        }
        // this._value = this.value;
        this.valueChange.emit(this.value);
        this.alerts.success(res.message);
      } else {
        this.alerts.error(res.message)
      }
      this.loader.hideSpinner();
    })
    console.log(selectedDocument, this.availableDocuments)
  }

  /**
   * Deletes a document from the available documents.
   *
   * This method deletes a document from the available documents, updates the
   * sequences of the remaining documents, and emits the updated value to the
   * parent component.
   *
   * @param document - The document to be deleted.
   * @param index - The index of the document in the available documents array.
   */
  deleteDoc(document , index){
    this.loader.showSpinner();
    if (document.image) {
      URL.revokeObjectURL(document.image);
    }
    this.tempArray.splice(index, 1);
    this.updateSequences();
    this.value = JSON.stringify(this.tempArray);
    this.valueChange.emit(this.value);
    this.loader.hideSpinner();
    //delete from db, tempArray and value then emit to form
    // const formData = new FormData();
    // formData.append("id", document.annotatedDocument);
    // formData.append("action", "delete");
    // formData.append('fileName', '')
    // var key = btoa(document);
    // this.baseService.upload(formData, 'dms', 'emrImage', key).subscribe(res => {
    //     if (res.errCode == 0) {
    // if(document.annotatedDocument){
    //   this.deleteImageApi$(document.annotatedDocument).subscribe(
    //     (res) => {
    //     if(res && res.errCode == 0) {
    //       if (typeof this.value === "string") {
    //         try {
    //           this.value = JSON.parse(this.value);
    //         } catch (error) {}
    //       }
          
          // const documentName = document?.documentName;
          // if(this.availableDocuments.length > 0 && documentName) {
          //   const docIndex = this.availableDocuments.findIndex(doc => doc.fileName === documentName);
          //   if(docIndex !== -1) {
          //     this.availableDocuments.splice(docIndex, 1);
          //   }
          // }

    //     }
    //   },
    //   (err) => {
    //       console.error('Error deleting document:', err);
    //       this.alerts.error(err.message || 'An error occurred while deleting the document');
    //       this.loader.hideSpinner();
    //   })
    // }
    //       this.alerts.success(res.message);
    //     }
    //   },
    //   (err) => {
    //     this.alerts.error(err.message);
    //     this.loader.hideSpinner();
    //   }
    // );
  }

  /**
   * Calls the API to delete a document from the database.
   * 
   * @param documentId - The ID of the document to delete.
   * @returns Observable with the API response.
   */
  private deleteImageApi$(documentId: string): Observable<any> {
    const formData = new FormData();
    formData.append("id", documentId);
    formData.append("action", "delete");
    formData.append('fileName', '');
    
    // Create a key for the request (base64 encoded document ID)
    const key = btoa(documentId);
    
    // Get resource and application from datasource or use defaults
    const documentResource = 'emrImage';
    const application = 'dms';
    
    return this.baseService.upload(formData, application, documentResource, key);
  }

  dataURLtoFile(dataurl, filename) {
    var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
  }

  setUpdate(document) {
    if (localStorage.getItem("annotationJson") != undefined && localStorage.getItem("annotationJson")) {
      localStorage.removeItem("annotationJson");
    }
    if (document != undefined && document && this.value != undefined && this.value) {
      let val = typeof this.value == 'string' ? JSON.parse(this.value) : this.value;
      let currrentImg = val.find(x => x.document === document.documentId);
      if (currrentImg != undefined && currrentImg) {
        localStorage.setItem('annotationJson', currrentImg.annotationJson);
      }
    }
  }

  /**
   * Sets an array of document metadata.
   *
   * This method sets an array of document metadata, including the document ID,
   * annotation JSON, annotated document ID, document name, image URL, and
   * sequence.
   *
   * @param selectedDocument - The selected document.
   * @param res - The response from the server.
   * @param event - The event containing the annotation state.
   */
  setArray(selectedDocument, res, event) {
    let newObj = {
      document: selectedDocument.imageId ? selectedDocument.imageId : selectedDocument.documentId,
      annotationJson: event.state,
      annotatedDocument: res.documentId,
      documentName: selectedDocument.fileName != undefined ? selectedDocument.fileName : (res.documentName ? res.documentName : ""),
      imageUrl: this.baseService.getApiEndpoint("dms") + 'emrImage' + '/image-response-entity?args=id:' + res.documentId + '&application=dms',
      sequence: selectedDocument?.sequence
    }
    if(this.isComponentArrayType){
      // Check if an object with the same documentName already exists
      const existingIndex = this.tempArray.findIndex(item => 
        item.documentName === newObj.documentName
      );
  
      // If it exists, replace it at its current index
      if (existingIndex !== -1) {
        console.log(`Replacing existing document: ${newObj.documentName} at index ${existingIndex+1}`);
        newObj.sequence = this.tempArray[existingIndex]?.sequence;
  
        // Replace the object at the same index
        this.tempArray[existingIndex] = newObj;
      } else {
        // If it doesn't exist, add it to the end
        this.tempArray.push(newObj);
      }
    } else {
      if (this.tempArray.length === 0) {
        // If empty, simply add the new object
        this.tempArray.push(newObj);
      } else {
        // If tempArray already has an element, replace it with the new one
        this.tempArray[0] = newObj;
      }
    }

    this.updateSequences();

    this.value = JSON.stringify(this.tempArray);
    console.log("temp array is: ", this.tempArray);
  }

  // --- Drag and Drop Methods (Start) ---

  /**
   * Handles the drag start event for reordering items.
   *
   * This method is called when a drag operation starts on an item. It sets the
   * draggingItemIndex to the index of the dragged item and adds a 'dragging'
   * class to the dragged element for visual feedback.
   *
   * @param event - The drag event.
   * @param index - The index of the dragged item.
   */
  onDragStart(event: DragEvent, index: number): void {
    this.draggingItemIndex = index;
    if (event.target instanceof HTMLElement) {
      event.target.classList.add('dragging');
    }
    if (event.dataTransfer) {
      event.dataTransfer.effectAllowed = 'move';
      event.dataTransfer.setData('text/plain', index.toString()); // Necessary for Firefox
    }
  }

  /**
   * Handles the drag over event for reordering items.
   *
   * This method is called when an item is dragged over another item. It
   * prevents the default behavior to allow the drop and adds a 'drag-over'
   * class to the target element for visual feedback.
   *
   * @param event - The drag event.
   * @param index - The index of the target item.
   */
  onDragOverItem(event: DragEvent, index: number): void {
    event.preventDefault();
    const target = event.currentTarget as HTMLElement;

    // Add visual feedback class
    if (!target.classList.contains('drag-over')) {
    document.querySelectorAll('.imageContainerselct.drag-over').forEach(el => {
      el.classList.remove('drag-over');
    });
    target.classList.add('drag-over');
  }
  }

  /**
   * Handles the drop event for reordering items.
   *
   * This method is called when an item is dropped on another item. It
   * reorders the items in the tempArray and updates the sequences of the
   * items.
   *
   * @param event - The drop event.
   * @param dropIndex - The index of the target item where the dragged item is dropped.
   */
  onDropOnItem(event: DragEvent, dropIndex: number): void {
    event.preventDefault();
    event.stopPropagation(); // Prevent the event from bubbling up to the container's drop handler

    const startIndex = this.draggingItemIndex;

    console.log("availableDocuments is ", this.availableDocuments);

    if (startIndex === null || startIndex === dropIndex) {
      this.cleanupDragState();
      return;
    }

    const itemToMove = this.tempArray[startIndex];

    // Remove from original position
    this.tempArray.splice(startIndex, 1);

    // Insert into new position in the modified array
    this.tempArray.splice(dropIndex, 0, itemToMove);
    this.updateSequences();

    console.log('tempArray AFTER drop ON ITEM:', this.tempArray);

    this.value = JSON.stringify(this.tempArray);
    this.valueChange.emit(this.value);
    this.cleanupDragState();
  }
  

  /**
   * Handles the drag over event for the container.
   *
   * This method is called when an item is dragged over the container. It
   * prevents the default behavior to allow the drop on the container itself
   * (e.g., empty spaces) and sets the drop effect to 'move'.
   *
   * @param event - The drag event.
   */
  onDragOverContainer(event: DragEvent): void {
    event.preventDefault();
    if (event.dataTransfer) {
      event.dataTransfer.dropEffect = 'move';
    }
  }

  /**
   * Handles the drop event on the container.
   *
   * This method is called when an item is dropped on the container. It
   * determines the insertion index based on the drop position within the
   * container, reorders the items in the tempArray, updates the sequences of
   * the items, and emits the updated value to the parent component.
   *
   * @param event - The drop event.
   */
  onDropInContainer(event: DragEvent): void {
    event.preventDefault();
    const startIndex = this.draggingItemIndex;

    if (startIndex === null) {
      this.cleanupDragState();
      return;
    }

    const itemToMove = this.tempArray[startIndex];

    // Determine insertion index based on drop position within the container
    let targetDropIndex = this.tempArray.length -1; // Default to end if logic below doesn't find a spot
    if (event.currentTarget instanceof HTMLElement) {
        const listElement = event.currentTarget;
        const childElements = Array.from(listElement.children).filter(
            el => el.classList.contains('imageContainerselct') && !el.classList.contains('drag-over')
        ) as HTMLElement[];

        targetDropIndex = childElements.length; // Default to end of list (current items)

        for (let i = 0; i < childElements.length; i++) {
            const el = childElements[i];
            const rect = el.getBoundingClientRect();
            if (event.clientX < rect.left + rect.width / 2) {
                targetDropIndex = i;
                break;
            }
        }
    }
    
    // Remove from old position first
    this.tempArray.splice(startIndex, 1);
    
    // Insert into new position in the modified array
    this.tempArray.splice(targetDropIndex, 0, itemToMove);
    this.updateSequences();

    console.log('tempArray AFTER drop ON CONTAINER:', this.tempArray);
    this.value = JSON.stringify(this.tempArray);
    this.valueChange.emit(this.value);
    this.cleanupDragState();
  }


  /**
   * Handles the drag end event.
   *
   * This method is called when a drag operation ends. It prevents the
   * default behavior and calls the cleanupDragState method to reset the drag
   * state.
   *
   * @param event - The drag event.
   */
  onDragEnd(event: DragEvent): void {
    event.preventDefault();
    this.cleanupDragState();
  }

  /**
   * Updates the sequence numbers of the items in the tempArray.
   *
   * This method iterates through the items in the tempArray and updates their
   * sequence numbers based on their current index in the array.
   */
  updateSequences() {
    this.tempArray.forEach((item, index) => {
      item.sequence = index + 1;
    });    
    this.sequenceNumber = this.tempArray.length;
  }

  /**
   * Cleans up the drag state.
   *
   * This method resets the drag state by removing the 'drag-over' class from
   * any elements that have it and setting the draggingItemIndex to null.
   */
  cleanupDragState(): void {
    if (this.draggingItemIndex !== null) {
      // Attempt to find the element that was being dragged and remove class
      // This is safer if the component re-renders and element references change
      document.querySelectorAll('.imageContainerselct.drag-over').forEach(el => {
        el.classList.remove('drag-over');
      });
    }
    this.draggingItemIndex = null;
  }

  /**
   * Cleans up object URLs to prevent memory leaks.
   *
   * This method iterates through the manually_added and availableDocuments
   * arrays and revokes the object URLs for the images to prevent memory
   * leaks.
   */
  cleanupObjectUrls() {
    // Clean manual uploads
    this.manually_added?.forEach(item => {
      if (item.image) URL.revokeObjectURL(item.image);
    });
    
    // Clean available documents
    this.availableDocuments?.forEach(doc => {
      if (doc.image) URL.revokeObjectURL(doc.image);
    });
  }

  /**
   * Angular lifecycle hook that is called when the component is destroyed.
   *
   * This method calls the cleanupObjectUrls method to revoke object URLs and
   * prevent memory leaks.
   */
  ngOnDestroy(): void {
    this.cleanupObjectUrls();
  }

}